export default {
  addNew: "Dodaj nowy",
  dialog: {
    editMaterial: "Edytuj materiał boardmeeting",
    addMaterial: "Dodaj materiał boardmeeting",
  },
  list: {
    headers: {
      id: "ID",
      material: "Materiał",
    },
  },
  elementType: {
    template: "Szablon",
    report: "Raport",
    presentation: "Prezentacja",
    workbook: "Workbook",
    article: "Artykuł",
  },
  materialType: {
    template: "Szablon",
    report: "Raport",
    presentation: "Prezentacja",
    workbook: "Workbook",
    article: "Artykuł",
  },
  element: {
    form: {
      material: "Powiązany materiał",
      image: "Zdjęcie",
      add: "Dodaj materiał boardmeeting",
      edit: "Edytuj materiał boardmeeting",
      name: "Nazwa",
      description: "Opis",
      main: "Wyróżniony",
      forCeo: "Dla CEO",
      type: "Typ",
      file: "Plik",
      addAuthor: "Dodaj autora",
      authors: "Autorzy",
      background: "Tło",
      image_horizontal: "Okładka pozioma",
    },
  },
  slide: {
    form: {
      name: "Nazwa",
      description: "Opis",
      image: "Zdjęcie",
      file: "Plik",
      element: "Powiązany materiał",
      editSlide: "Edytuj slajd",
      addSlide: "Dodaj slajd",
    },
  },
  slides: {
    list: {
      headers: {
        id: "ID",
        name: "Nazwa",
        description: "Opis",
        type: "Typ",
        series: "Seria",
        image: "Obrazek",
        file: "Plik",
        element: "Powiązany materiał",
      },
    },
  },
};
